import { Link } from "@tanstack/react-router";
import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { SigBreadcrumb } from "../components/SigBreadcrumb";
import { SigExplainer } from "../components/SigExplainer";
import { SignatureMaker } from "../components/SignatureMaker";

export function TypeSignaturePage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <SigBreadcrumb current={m.sig_nav_type()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.sig_type_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.sig_type_intro()}
          </p>
        </header>

        <SignatureMaker defaultMode="type" />

        <p className="mt-4 text-sm text-muted-foreground">
          {m.sig_type_draw_hint()}{" "}
          <Link
            to="/signature-maker"
            className="text-primary underline-offset-4 hover:underline"
          >
            {m.sig_nav_main()}
          </Link>
        </p>

        <SigExplainer
          howTo={m.sig_type_howto()}
          faqs={[
            { q: m.sig_type_faq1_q(), a: m.sig_type_faq1_a() },
            { q: m.sig_type_faq2_q(), a: m.sig_type_faq2_a() },
            { q: m.sig_type_faq3_q(), a: m.sig_type_faq3_a() },
            { q: m.sig_type_faq4_q(), a: m.sig_type_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
